/**
 * Admin App Main Component
 *
 * Root component for the RedFox Thank You admin interface.
 *
 * @package RedfoxThankYou
 * @since   1.0.0
 */

import { createRoot } from 'react-dom/client';
import { Router } from 'wouter';
import { useHashLocation } from 'wouter/use-hash-location';

import { App } from './components';
import { AdminContainer } from './styled';


/**
 * Admin App Component
 *
 * Main app component
 */
const AdminApp = () => {
	return (
		<AdminContainer>
			<Router hook={useHashLocation}>
				<App />
			</Router>
		</AdminContainer>
	);
};

/**
 * Initialize the admin app
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const rootElement = document.getElementById( 'redfox-thank-you-root' );
	if ( rootElement ) {
		const root = createRoot( rootElement );
		root.render( <AdminApp /> );
	}
} );
